module.exports = __webpack_public_path__ + "static/img/1_1_6_1.4e50d16b.jpg";